/**
 * Resolve internal app URLs (respecting base path).
 */

import { asset } from '$app/paths';

/**
 * Returns the complete path for a static asset by joining it with the base
 * assets URL provided by SvelteKit (`$app/paths`).
 *
 * Normalises slashes so that callers can pass paths with or without a leading
 * slash, and the configured `assets` base can end with or without a trailing
 * slash, without producing doubled or missing separators.
 *
 * @param {string} [staticAssetPath] - The path of the static asset (relative to `assets`).
 * @returns {string} The complete path of the static asset.
 *
 * @example
 *   getPath('images/foo.png'); // -> '<assets>/images/foo.png'
 *   getPath('/images/foo.png'); // -> '<assets>/images/foo.png'
 *   getPath(); // -> '<assets>'
 */
export const getPath = (staticAssetPath = '') => {
  // `asset('')` returns the configured assets base (or base path) on its
  // own, matching the old `assets` constant exactly. For a real file path
  // we strip leading slashes so the resulting URL never doubles the
  // separator that `asset(...)` adds back when it joins the base with the
  // file path.
  const path = String(staticAssetPath).replace(/^\/+/, '');
  return asset(path ? `/${path}` : '');
};

export default getPath;
